import moment from 'moment';
import { DangerousRounded, ReportGmailerrorredRounded, CheckCircle, Check, Close } from '@mui/icons-material';

const divStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    borderRadius: '10px',
    backgroundColor: '#d3d3d3',
    padding: '6px'
};

const iconRedStyle = { color: 'red', fontSize: '20px' };
const iconOrangeStyle = { color: 'orange', fontSize: '20px' };
const iconGreenStyle = { color: 'green', fontSize: '20px' };
const textRightStyle = { textAlign: 'right', fontSize: '12px' };
const flexSpaceBetweenStyle = { display: 'flex', justifyContent: 'space-between' };
const checkGreenStyle = { color: 'green' };
const checkRedStyle = { color: 'red' };

export const CensusFileStatus = ({ censusData }) =>
{
    const getIcon = () =>
    {
        if (!censusData)
        {
            return <DangerousRounded style={iconRedStyle} />
        } else if (!censusData.isEmployeeIDMatch && !censusData.isEmailMatch)
        {
            return <DangerousRounded style={iconRedStyle} />
        }
        const isCensusDateMoreThan30Days = moment().diff(moment(censusData.censusDate), 'days') > 30;
        if (isCensusDateMoreThan30Days)
        {
            return <ReportGmailerrorredRounded style={iconOrangeStyle} />
        }
        return <CheckCircle style={iconGreenStyle} />
    }
    return (
        <div style={divStyle}>
            <div className='d-flex align-items-center' style={{ gap: 4 }}>
                <div>
                    <div>Census Status</div>
                    <div style={textRightStyle}>{censusData ? moment(censusData.censusDate).format('MM/DD/YYYY') : 'No Census File Found'}</div>
                </div>
                {getIcon()}
            </div>
            {
                censusData && <div className='d-flex' style={{ gap: 4 }}>
                    <div style={flexSpaceBetweenStyle}>Email {censusData.isEmailMatch ? <Check style={checkGreenStyle} /> : <Close style={checkRedStyle} />}</div>
                    <div style={flexSpaceBetweenStyle}>EID {censusData.isEmployeeIDMatch ? <Check style={checkGreenStyle} /> : <Close style={checkRedStyle} />}</div>
                </div>
            }
        </div>
    )
}